.container {
  padding: 15px;
  width: 230px;
}

.title {
  font-weight: 600;
  margin-bottom: 5px;
}